export const appName = 'Dynamic PDF';

export enum EventName {
    Feedback = 'User rated app as',
}
